import React from "react";
import { Spinner } from "../components/ui/spinner";
type LoadingProps = {
  text?: string;
};
const Loading = ({ text }: LoadingProps) => {
  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <Spinner className="size-8" />
      {text && (
        <span className="text-sm text-muted-foreground">
          {text || "loading..."}
        </span>
      )}
    </div>
  );
};

export default Loading;
